import {Injectable} from '@angular/core';
import {DataService} from '../data.service';
import { HttpClient } from '@angular/common/http';
import {Observable, catchError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BroadcastMessagesService extends DataService {

  private baseURI = this.apiUri + '/broadcastmessages/';

  constructor(http: HttpClient) {
    super(http);
  }

  getMessages(): Observable<any> {
    this.setUri(this.baseURI + 'get');
    return this.get().pipe(catchError(this.handleError));
  }

  createMessage(message: any): Observable<string> {
    return this.http.post<string>(this.baseURI + 'create', message);
  }

  updateMessage(message: any): Observable<string> {
    return this.http.post<string>(this.baseURI + 'update', message);
  }

  deleteMessage(message: any): Observable<string> {
    return this.http.post<string>(this.baseURI + 'delete', message);
  }

}
